<template>
    <div class="login-page">
      <div class="login-box" @keyup.enter="login()">
        <div class="card card-outline card-primary">
          <div class="card-header text-center">
            <p class="h1 m-2">Venta<b>X</b>press</p>
          </div>
          <div class="card-body">
            <p class="login-box-msg">Ingrese sus credenciales</p>
  
            <div class="input-group mb-3">
              <input type="email" class="form-control" placeholder="Usuario" v-model="usuario">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-user"></span>
                </div>
              </div>
            </div>
            <div class="input-group mb-3">
              <input type="password" class="form-control" placeholder="Password" v-model="password">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" @click="login()" class="btn btn-primary btn-block">Ingresar</button>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginVue',
    data() {
      return {
        usuario: '',
        password: '',
      }
    },
    methods: {
      async login() {
        try {
          const data = {
            username: this.usuario,
            password: this.password
          }
          const response = await this.$axios.post('api/auth/login/', data)
  
          if (response.status === 200) {
            // 🔑 Guardamos los tokens
            localStorage.setItem('access', response.data.access)
            localStorage.setItem('refresh', response.data.refresh)
  
            // 🔑 Configurar Axios para enviar siempre el JWT
            this.$axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`
  
            // 🔑 Guardar datos extra del usuario
            localStorage.setItem('username', response.data.username)
            localStorage.setItem('idusuario', response.data.idusuario)
            localStorage.setItem('grupo_id', response.data.grupo_id)
            localStorage.setItem('grupo_nombre', response.data.grupo_nombre)
            localStorage.setItem('idSucursal', response.data.idSucursal)
            localStorage.setItem('sucursal', response.data.sucursal)
            localStorage.setItem('permisoDscto', response.data.permisoDscto)
            localStorage.setItem('empresa', response.data.empresa)
            localStorage.setItem('idEmpresa', response.data.idEmpresa)
            localStorage.setItem('rucEmpresa', response.data.rucEmpresa)
            localStorage.setItem('produccion', response.data.produccion)
            localStorage.setItem('db_name', response.data.db_name)
            
            this.$root.usuarioAuth = true
  
            // ✅ Redirigir al dashboard
            window.location.href = '/pedidos/nuevo'
            //this.$router.push('/dashboard')
          }
        } catch (error) {
          this.$toastr.error('Usuario y clave incorrectas')
          console.error(error)
        }
      }
    }
  }
  </script>
  